const MODULE_NAME = 'BubblesModule';

export const SET_CURRENT_TASK = `${MODULE_NAME}/SET_CURRENT_TASK`;
export const SET_BUBBLES = `${MODULE_NAME}/SET_BUBBLES`;
export const ADD_SYNCHRONIZED_BUBBLE = `${MODULE_NAME}/ADD_SYNCHRONIZED_BUBBLE`;
export const REMOVE_SYNCHRONIZED_BUBBLE = `${MODULE_NAME}/REMOVE_SYNCHRONIZED_BUBBLE`;
export const LOCAL_SET_BUBBLES = 'SET_BUBBLES';
export const LOCAL_REMOVE_BUBBLE = 'REMOVE_BUBBLE';
export const LOCAL_UPDATE_BUBBLE = 'LOCAL_UPDATE_BUBBLE';
